module.exports = __webpack_public_path__ + "static/media/consume-yardnapha.beb5b146.mp3";